module.exports = __webpack_public_path__ + "static/p4-8be0ea7364924f6d07a523b375cbdfe2.jpg";